export const CHANGE_SELECTION = (selections: string[]) => {
  return { type: "CHANGE_SELECTION", payload: selections };
};
